import React from 'react';
import FreshChat from '../FreshChat';
import { RoutesForStaticSite } from '../../constants/routeConstants';
import ErrorBoundary from '../../modules/errorBoundary';
import CookiesBanner from '../CookiesBanner';
import Router from '../Router';
import { useSelector } from 'react-redux';
import { getHub } from '../App/selectors';
import { getHubByRoutingHub } from 'helpers/hubs';
import config from 'config';
import { isCyHub } from 'modules/auth/helpers/hubs';

const hideChatForStaticPage = () => {
  return window.location.pathname.includes(RoutesForStaticSite.DAY1X_SUBSCRIBTION);
};

const AppLayout = () => {
  const routingHub = useSelector(getHub);
  const currentHub = getHubByRoutingHub(routingHub);
  //TODO: remove in FDS-3902
  const cyHub = isCyHub(currentHub?.KEY);
  const { FRESH_CHAT } = config;
  const showFreshChat = !hideChatForStaticPage() && !cyHub && FRESH_CHAT.ALLOWED;

  return (
    <ErrorBoundary>
      <Router />
      {showFreshChat ? <FreshChat config={FRESH_CHAT} /> : null}
      <CookiesBanner />
    </ErrorBoundary>
  );
};

export default AppLayout;
